/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type VariationToolPost = {
  /**
   * The key of the tool to use.
   */
  key: string;
  /**
   * The version of the tool.
   */
  version: number;
};

/** @internal */
export const VariationToolPost$inboundSchema: z.ZodType<
  VariationToolPost,
  z.ZodTypeDef,
  unknown
> = z.object({
  key: z.string(),
  version: z.number().int(),
});
/** @internal */
export type VariationToolPost$Outbound = {
  key: string;
  version: number;
};

/** @internal */
export const VariationToolPost$outboundSchema: z.ZodType<
  VariationToolPost$Outbound,
  z.ZodTypeDef,
  VariationToolPost
> = z.object({
  key: z.string(),
  version: z.number().int(),
});

export function variationToolPostToJSON(
  variationToolPost: VariationToolPost,
): string {
  return JSON.stringify(
    VariationToolPost$outboundSchema.parse(variationToolPost),
  );
}
export function variationToolPostFromJSON(
  jsonString: string,
): SafeParseResult<VariationToolPost, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => VariationToolPost$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'VariationToolPost' from JSON`,
  );
}
